/* eslint-disable import/prefer-default-export */
import { API_URL } from '../../../utils/config';

export const LOGGED_IN_USER_PROFILE_URL = `${API_URL}/employee/loggedOnEmployee`;
